export default __webpack_public_path__ + "static/13-dc6c3df25ad318b113b988020ee64a40.jpg";